import { Anchor, Button } from "@aircall/ds";
import { Trans, useTranslation } from "react-i18next";
import TranscriptionOff from "@/assets/transcription_off.svg?react";
import { DASHBOARD_URL } from "@/constants/environment.constants";
import { useGetLine } from "@/hooks/useGetLine/useGetLine";
import { useHasReadLinePermission } from "@/hooks/useHasReadLinePermission/useHasReadLinePermission";
import { useUpdateLineSettings } from "@/hooks/useUpdateLineSettings/useUpdateLineSettings";
import { TranscriptionIllustrationLayout } from "../TranscriptionIllustrationLayout/TranscriptionIllustrationLayout";
import { TranscriptionMessageTitle } from "../TranscriptionMessageTitle/TranscriptionMessageTitle";
import { TranscriptionSubTitle } from "../TranscriptionSubTitle/TranscriptionSubTitle";

export function TranscriptionNotEnabledMessage() {
  const { t } = useTranslation();
  const { line } = useGetLine();
  const hasReadLinePermission = useHasReadLinePermission();

  const handleOnClick = useUpdateLineSettings();

  const lineName = line?.name ?? "";
  return (
    <TranscriptionIllustrationLayout data-test="transcription-not-enabled-message">
      <TranscriptionOff />
      <TranscriptionMessageTitle data-test="transcription-off-title">
        {t("no_transcript.off_title")}
      </TranscriptionMessageTitle>
      {hasReadLinePermission && (
        <div className="flex flex-col items-center gap-4">
          <TranscriptionSubTitle data-test="transcription-off-description">
            <Trans
              i18nKey="no_transcript.off_description"
              values={{ lineName }}
              components={{
                1: (
                  <Anchor
                    href={`${DASHBOARD_URL}numbers/${line?.ID}`}
                    target="blank"
                  />
                ),
              }}
            />
          </TranscriptionSubTitle>
          <Button onClick={handleOnClick}>{t("turn_on")}</Button>
        </div>
      )}
    </TranscriptionIllustrationLayout>
  );
}
